<template>
  <div class="space centre-page">
    <SiteNav></SiteNav>
    <div class="space--wrapper">
      <div class="space--information">
        <div ref="container" class="space--inner-scroll">
          <SpacesHeader :title="listingGroup.titleLong ? listingGroup.titleLong : listingGroup.title" :address="listingGroup.address" :avatar="listingGroup.featuredLogoUrl"></SpacesHeader>
          <SpacesInformation :data="listingGroup.description" :categories="categories" :center="true" :opening_time="listingGroup.openingTime" :access_time="listingGroup.accessTime"></SpacesInformation>
          <SpacesStatistics v-if="listingGroup.storeNumber > 0" :surface_area="listingGroup.surfaceArea" :store_number="listingGroup.storeNumber" :average_length_stay="listingGroup.averageLengthStay" :footfall_yearly="listingGroup.footfallYearly"></SpacesStatistics>

          <SpacesRequirements></SpacesRequirements>
          <SpacesTable :data="footfall"></SpacesTable>
          <SpacesTags :data="amenities" :source_type="'centre'"></SpacesTags>
          <SpacesAccordian :data="faq"></SpacesAccordian>
          <MessageWidget :sender="user.id" :receiver="listingGroup.userId" v-if="user" :id="listingGroup.id" :source_type="'listing_group'"></MessageWidget>
          <BasicMap v-if="listingGroup.latitude && listingGroup.longitude" :data="{lat: listingGroup.latitude, lng: listingGroup.longitude}" :title="null"></BasicMap>
        </div>
      </div>
      <div class="space--spaces-list" :class="toggleView ? 'is--toggled' : ''">
        <div class="toggle-pane__header">
          <div class="toggle-pane__header-title">Spaces</div>
          <a href="#" @click.prevent="closeMobileToggle()" class="toggle-pane__header-close">
            <img src="/assets/icon_close.svg" alt="Close">
          </a>
        </div>
        <div class="toggle-pane__content">
          <SpacesList v-if="listingGroup && listings" :data="listings" :columns="2" :returnCenters="returnCenters" :showCart="true" :isLoading="isLoading"></SpacesList>
        </div>
      </div>
    </div>

    <div class="space--filters" :class="toggleFilters ? 'is--toggled' : ''">
        <div class="toggle-pane__header">
          <div class="toggle-pane__header-title">Filters</div>
          <a href="#" @click.prevent="closeMobileToggle()" class="toggle-pane__header-close">
            <img src="/assets/icon_close.svg" alt="Close">
          </a>
        </div>
        <div class="toggle-pane__content">
          <FilterBar :spaceTitle="listingGroup.title" :disabled="['property_type', 'footfall', 'location']"></FilterBar>
        </div>
    </div>

    <div class="toggle-menu">
      <button @click.prevent="toggleMobileFilters()" class="toggle-menu__button" :class="toggleFilters ? 'is--active' : ''">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.6 16.2C12.7974 16.2 16.2 12.7974 16.2 8.6C16.2 4.40263 12.7974 1 8.6 1C4.40263 1 1 4.40263 1 8.6C1 12.7974 4.40263 16.2 8.6 16.2Z" stroke="#EBEDF3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.0004 17L15.4004 15.4" stroke="#EBEDF3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{$store.getters.language.filters}}
      </button>
      <button @click.prevent="toggleMobileView()" class="space--toggle-view--button" :class="toggleView ? 'is--active' : ''">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 16.5759H17" stroke="#EBEDF3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.75977 16.576L1.79977 6.95197C1.79977 6.46397 2.03177 6.00001 2.41577 5.69601L8.01581 1.336C8.59181 0.888 9.39981 0.888 9.98381 1.336L15.5838 5.688C15.9758 5.992 16.1998 6.45597 16.1998 6.95197V16.576" stroke="#EBEDF3" stroke-miterlimit="10" stroke-linejoin="round"/>
        <path d="M11.8 7.77588H6.2C5.536 7.77588 5 8.31188 5 8.97588V16.5759H13V8.97588C13 8.31188 12.464 7.77588 11.8 7.77588Z" stroke="#EBEDF3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.40039 11.9758V13.1758" stroke="#EBEDF3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.7998 4.97583H10.1998" stroke="#EBEDF3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{$store.getters.language.spaces}}
      </button>
    </div>

    <div @click.prevent="closeMobileToggle()" class="space-filters-bg" :class="toggleFilters || toggleView ? 'is--toggled' : ''"></div>

    <div class="space--map-trigger">
      <ButtonPrimary @buttonClick="mapModalVisible = true" :title="$store.getters.language.view_map"></ButtonPrimary>
    </div>

    <SpacesModal v-if="mapModalVisible" @close="mapModalVisible = false" :large="true">
      <FillitMap :id="'siKwSiSYq2qsCeUHLx7p'" :slug="'centro-commerciale-casetta-mattei'" v-if="listingGroup.slug == 'centro-commerciale-casetta-mattei'"></FillitMap>
      <mapplic-map id="space-map" :data-json="`https://mapplic.com/getMapData?id=${mapId}`" v-if="listingGroup.slug != 'centro-commerciale-casetta-mattei'"></mapplic-map>
    </SpacesModal>

  </div>

</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import SiteNav from "../../components/global/SiteNav"
import SpacesInformation from "../../components/search/SpacesInformation"
import SpacesList from "../../components/search/SpacesList"
import SpacesTable from "../../components/search/SpacesTable"
import SpacesRequirements from "../../components/search/SpacesRequirements"
import SpacesTags from "../../components/search/SpacesTags"
import SpacesAccordian from "../../components/search/SpacesAccordian"
import SpacesHeader from "../../components/search/SpacesHeader"
import SpacesStatistics from "../../components/search/SpacesStatistics"
import BasicMap from "../../components/search/BasicMap"
import DatePicker from "../../components/search/DatePicker"
import FilterBar from "../../components/search/FilterBar"
import MessageWidget from "../../components/search/MessageWidget"
import ButtonPrimary from "../../components/global/ButtonPrimary"
import SpacesModal from "../../components/search/SpacesModal"
import FillitMap from "../../components/global/FillitMap"

import gql from 'graphql-tag'

export default {
  name: 'Centre',
  data: () => ({
    toggleView: false,
    toggleFilters: false,
    listingGroup: {},
    listings: [],
    returnCenters: false,
    searchResults: [],
    isLoading: true,
    user: null,
    mapId: '',
    mapModalVisible: false,
    hide_message_button: false,
    location: {
      lat: '53.2870256',
      lng: '-6.2397114999999985'
    },
    footfall: {
      title: 'Footfall',
      description: '',
      values: [{
        name: 'Weekly Average',
        value: '100k - 200k'
      }]
    },
    amenities: {
      title: 'Amenities',
      values: []
    },
    faq: {
      title: 'Additional Info',
      description: 'From the Landlord',
      values: [{
        question: 'House Rules',
        answer: 'Neat dress essential. The company must ensure its employees portray a clean, smart and professional appearance while conducting promotions. Enquiries'
      }, {
        question: 'Cancellation Policy',
        answer: 'Tenants can cancel up to 48 hours before for a full refund.'
      }, {
        question: 'Insurance & Safety',
        answer: 'Public liability insurance of €6.5 million and €13 million employers liability where applicable. All companies must ensure their employees, agents and sub-contractors comply with all relevant health & safety legislation when on the centre premises. All visitors must sign the visitors log book daily on entry and exit of the store. Promotional stands and equipment must be carefully positioned to ensure it does not block or impede access or egress from the building. Fire exits and firefighting equipment must be kept clear and available at all times.'
      }]
    },
    categories: ['Retail In', 'Retail Out', 'Pop Up']
  }),
  components: {
    SiteNav,
    SpacesInformation,
    SpacesList,
    SpacesTable,
    SpacesRequirements,
    SpacesTags,
    SpacesAccordian,
    SpacesHeader,
    SpacesStatistics,
    BasicMap,
    DatePicker,
    FilterBar,
    MessageWidget,
    ButtonPrimary,
    SpacesModal,
    FillitMap

  },
  watch: {
    // Watch for state changes
    '$store.state.rent': {
      handler (state) {
        this.listingsQuery()
        this.urlState()
      },
      deep: true
    }
  },
  mounted () {
      this.getUser()
  },
  created () {
    // Watch for back button changes
    var self = this
    this.getListingGroup()
    /*
    var queryString = window.location.search
    if (queryString) {
      console.log(queryString)
      this.populateFromQuery()
      console.log(queryString)
    }
    window.addEventListener('popstate', function (event) {
      // if (event.state) {
        // self.populateFromQuery()
      // }
    })
    */
  },
  methods: {
    getUser() {
        var self = this
        axios
            .get('/api/searches/get_user')
            .then(response => {
                if (response.data.response == true) {
                    self.user = response.data
                }
            })
    },
    scrollDown() {
        const container = this.$refs.container;
        container.scrollTop = container.scrollHeight;
        this.hide_message_button = true;
    },
    toggleMobileView (active) {
      this.toggleView = !this.toggleView
    },
    toggleMobileFilters () {
      this.toggleFilters = !this.toggleFilters
    },
    closeMobileToggle () {
      this.toggleView = false
      this.toggleFilters = false
    },
    getListingGroup () {
      this.listingGroupsQuery()
    },
    async listingGroupsQuery () {
      var self = this
      const response = await this.$apollo.query({
        query: gql`
        query getListingGroup ($slug: String!) {
          listingGroup(id: "", slug: $slug) {
            id
            userId
            name
            slug
            title
            titleLong
            subtitle
            description
            hexColour
            storeNumber
            averageLengthStay
            isShoppingCentre
            address
            amenities {
              title
            }
            featuredDescription
            featuredImageUrl
            iframeEmbed
            featuredLogoUrl
            featuredImage2Url
            featuredImage3Url
            weight
            surfaceArea
            openingTime
            accessTime
            footfallYearly
            latitude
            longitude
            houseRules
            insuranceAndSafety
            additionalNotes
            cancellationPolicy
            footfall
            mapClusterLogoUrl
            createdAt
            updatedAt
            listings {
              edges {
                node {
                  id
                  title
                  address
                  price
                  currentUse
                  description
                  status
                  houseRules
                  insuranceAndSafety
                  additionalNotes
                  county
                  latitude
                  longitude
                  liabilityInsurance
                  cancellationPolicy
                  capacity
                  slug
                  image1Url
                  image2Url
                  image3Url
                  createdAt
                  updatedAt
                  spaceSize
                  spaceSizeType
                  categoriesListings {
                    edges {
                      node {
                        listingId
                        categoryId
                        categoryName
                      }
                    }
                  }
                }
              }
            }
          }
        }`,
        variables: {
          slug: self.$route.params.slug
        }
      }).then((response) => {
        self.listingGroup = response.data.listingGroup
        self.listingsQuery()
        // self.searchResults = response.data.listingGroup.listings
        // self.searchResults = response.data.listingGroup.listings
        self.faq = {
            title: self.$store.getters.language.additional_info,
              description: self.$store.getters.language.from_landlord,
              values: [{
            question: self.$store.getters.language.house_rules,
            answer: response.data.listingGroup.houseRules
          }, {
            question: self.$store.getters.language.cancel_policy,
            answer: response.data.listingGroup.cancellationPolicy
          }, {
            question: self.$store.getters.language.insurance_safety,
            answer: response.data.listingGroup.insuranceAndSafety
          }]
        }

        self.amenities = {
            title: self.$store.getters.language.amenities,
            values: response.data.listingGroup.amenities
        }

        // Format footfall
        var footfallArray = []
        if (response.data.listingGroup.footfall) {
          footfallArray.push({
            name: self.$store.getters.language.weekly_average,
            value: response.data.listingGroup.footfall.toLocaleString()
          })
        }
        if (response.data.listingGroup.footfallYearly) {
          footfallArray.push({
            name: self.$store.getters.language.yearly_average,
            value: response.data.listingGroup.footfallYearly.toLocaleString()
          })
        }

        self.footfall = {
            title: self.$store.getters.language.footfall,
            values: footfallArray
        }

        self.categories = response.data.listingGroup.name.split(',')
        self.location = {
          lat: self.listingGroup.latitude,
          lng: self.listingGroup.longitude,
        }
        self.mapId = self.listingGroup.iframeEmbed

      }).catch((error) => {
        console.log(error)
        self.$router.push({ name: 'PageNotFound' })
      })
    },
    async listingsQuery () {
    var self = this
    this.isLoading = true
    var response
      response = await this.$apollo.query({
        query: gql`
        query getListings ($id: Int!, $category: [String!], $amenityIds: [Int!], $fromDate: String, $toDate: String, $priceFrom: Int, $priceTo: Int, $featureIds: [String!]) {
          listings(listingGroupId: $id, category: $category, amenityIds: $amenityIds, fromDate: $fromDate, toDate: $toDate, priceFrom: $priceFrom, priceTo: $priceTo, featureIds: $featureIds) {
            edges {
              node {
                id
                title
                address
                price
                currentUse
                description
                status
                houseRules
                insuranceAndSafety
                additionalNotes
                county
                latitude
                longitude
                liabilityInsurance
                cancellationPolicy
                capacity
                spaceSize
                spaceSizeType
                slug
                image1Url
                image2Url
                image3Url
                listingGroupId
                createdAt
                updatedAt
                spaceSize
                spaceSizeType
                categoriesListings {
                    edges {
                      node {
                        listingId
                        categoryId
                        categoryName
                      }
                    }
                 }
              }
            }
          }
        }`,
        variables: {
          id: parseInt(this.listingGroup.id),
          category: self.$store.state.rent.category_id,
          amenityIds: self.$store.state.rent.amenity_id,
          featureIds: self.$store.state.rent.feature_id,
          fromDate: self.$store.state.rent.from_date,
          toDate: self.$store.state.rent.to_date,
          priceFrom: self.$store.state.rent.from_price,
          priceTo: self.$store.state.rent.to_price
        }
      }).then((response) => {
        self.listings = response.data.listings.edges
        self.isLoading = false
      })
    },
    populateFromQuery () {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
      var rent = {
        category_id: urlParams.get('category_id') ? urlParams.get('category_id').split(',').map(element => { return String(element) }) : [],
        amenity_id: urlParams.get('amenity_id') ? urlParams.get('amenity_id').split(',').map(element => { return Number(element) }) : [],
        from_date: urlParams.get('from_date') ? urlParams.get('from_date') : null,
        to_date: urlParams.get('to_date') ? urlParams.get('to_date') : null,
        from_price: urlParams.get('from_price') ? urlParams.get('from_price') : null,
        to_price: urlParams.get('to_price') ? urlParams.get('to_price') : null,
        from_footfall: urlParams.get('from_footfall') ? urlParams.get('from_footfall') : null,
        to_footfall: urlParams.get('to_footfall') ? urlParams.get('to_footfall') : null
      }
      this.$store.commit('replace', rent)
    },
    urlState () {
      var params = this.$store.state.rent
      var queryUrl = window.location.href.split('?')[0]
      var queryParam = Object.keys(params).filter(function (key) {
        if (Array.isArray(params[key]) === true && params[key].length > 0) {
          return key
        } else if (Array.isArray(params[key]) === false && params[key] !== '' && params[key] !== null && key !== 'distance' && key !== 'bounds' && key !== 'translations') {
          return key
        } else {
          return false
        }
      }).map(function (key) {
        return encodeURIComponent(key) + '=' + params[key]
      }).join('&')
      if (window.location.search !== '?' + queryParam) {
        if (queryParam !== '') {
          history.replaceState(queryUrl, null, '?' + queryParam)
        } else {
          history.replaceState(queryUrl, null, queryUrl)
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../scss/global/includes";

.toggle-pane__header {
  display: none;
  @include breakpoint(tablet-landscape) {
    display: block;
    position: relative;
    z-index: 1006;
    width: 100%;
    padding: 24px 32px;
    @include responsive-text-size('Header--12--BOLD');
    &:after {
      content: "";
      position: absolute;
      left: 32px;
      bottom: 0;
      right: 32px;
      height: 1px;
      background: $divider-dark;
    }
  }
} 

.toggle-pane__content {
  @include breakpoint(tablet-landscape) {
    position: absolute;
    top: 64px;
    left: 0;
    bottom: 0;
    right: 0;
  }
}

.toggle-pane__header-close {
  @include breakpoint(tablet-landscape) {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 24px;
    height: 24px;
  }
} 

.space--spaces-list {
  position: fixed;
  top: 70px;
  right: 0px;
  bottom: 0;
  width: calc(50% - (230px / 2));

  &.is--toggled {
    @include breakpoint(tablet-landscape) {
      pointer-events: auto;
      visibility: visible;
      @include transform(translate(0, 0));
    }
  }

  @include breakpoint(tablet-landscape) {
    position: fixed;
    pointer-events: none;
    visibility: hidden;
    left: 0;
    right: 0;
    z-index: 100009;
    width: 100%;
    bottom: 0px;
    border-radius: 4px 4px 0 0;
    height: calc(100vh - 70px);
    height: calc(100svh - 70px);
    top: auto;
    background: $light-grey;
    @include ease;
    @include transform(translate(0, 100%));
  }
}

.space--filters {

  &.is--toggled {
    @include breakpoint(tablet-landscape) {
      pointer-events: auto;
      visibility: visible;
      @include transform(translate(0, 0));
    }
  }

  @include breakpoint(tablet-landscape) {
    position: fixed;
    pointer-events: none;
    visibility: hidden;
    left: 0;
    right: 0;
    z-index: 100009;
    width: 100%;
    bottom: 0px;
    border-radius: 4px 4px 0 0;
    height: calc(100vh - 70px);
    height: calc(100svh - 70px);
    background: $light-grey;
    top: auto;
    @include ease;
    @include transform(translate(0, 100%));
  }
}

.space--wrapper {
  padding-top: 80px;
  position: relative;
  @include breakpoint(tablet-landscape) {
    padding-top: 70px;
  }
}
.space--information {
  position: fixed;
  top: 70px;
  left: 230px;
  bottom: 0;
  width: calc(50% - (230px / 2));
  @include breakpoint(tablet-landscape) {
    width: 100%;
    left: 0;
    top: 0;
    position: relative;
    @include transition(opacity 0.4s ease-in-out);
    &.is--toggled {
      display: block;
    }
    &.is--hidden {
      display: none;
    }
  }
}
.space--inner-scroll {
  padding: 16px 0 16px 16px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  &::-webkit-scrollbar {
      display: none;
  }

  @include breakpoint(tablet-landscape) {
    gap: 16px;
    padding: 16px;
    position: relative;
    width: 100%;
    overflow-y: unset;
    padding: 16px 16px 88px 16px;
  }
}

.space--toggle-filters {
  position: fixed;
  top: 80px;
  width: 90px;
  left: 50%;
  display: none;
  grid-template-columns: 1fr;
  text-align: center;
  background: #F7F7F7;
  z-index: 1009;
  box-shadow: 0px 0px 5px 0px rgba(122, 122, 122, 0.5);
  border-radius: 4px;
  @include transform(translate(-50%, 0));

  @include breakpoint(tablet-landscape) {
    display: grid;
  }

  button {
    height: 34px;
    font-size: 16px;
    font-family: $font-medium;
    background: #FFFFFF;
    color: $primary;
    border: 1px solid $primary;
    border-radius: 4px;
  }
}

.space-filters-bg {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  @include ease;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10009;
  background: rgba(#000000, 0.3);
  @include breakpoint(tablet-landscape) {
    &.is--toggled {
      opacity: 1;
      pointer-events: auto;
      visibility: visible;
    }
  }
}

.toggle-menu {
  position: fixed;
  bottom: 0px!important;
  left: 0;
  right: 0;
  display: none;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  background: $primary;
  z-index: 1009;
  // box-shadow: 0px 0px 5px 0px rgba(122, 122, 122, 0.5);
  overflow: hidden;
  border-radius: 4px 4px 0 0;

  &:after {
    content: "";
    position: absolute;
    left: calc(50% - 0.5px);
    width: 1px;
    background: $divider-light;
    top: 10px;
    bottom: 10px;
  }

  @include breakpoint(tablet-landscape) {
    display: grid;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 8px;
    color: $divider-light;
    height: 72px;
    @include responsive-text-size('Button--12--BOLD');
  }
}
.fixed-circle {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 80px;
  height: 80px;
  border-radius: 50px;
  background-color: white;
  color: $primary;
  border: 1px solid $primary;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
}

.circle-text {
  color: $primary;
  font-size: 18px;
}

.space--map-trigger {
  position: fixed;
  bottom: 40px;
  right: calc((50% - 115px) / 2);
  z-index: 1005;
  transform: translate(50%, 0);
  @include breakpoint(tablet-landscape) {
    display: none;
  }
}
</style>
